/** * Created by lobin on 2019/2/1. */
<template>
  <div class="jobexpect-edit">
    <el-form
      :model="jobExpectData"
      ref="jobExpect"
      label-width="100px"
      class="myresume-form"
      :rules="rules"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="求职类型：" prop="jobHuntType">
            <el-select
              v-model="jobExpectData.jobHuntType"
              placeholder="请选择求职类型"
            >
              <el-option
                :label="item.name"
                v-for="item in positionType"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
            
        </el-col>

        <el-col :span="16">
          <el-form-item label="职业类型：" prop="desirePositionType">
            <el-cascader
                style="width: 100%;"
                placeholder="职业类型"
                v-model="jobExpectData.desirePositionType"
                :options="allJob"
                :props="{ expandTrigger:'hover',value:'code',label:'name'}"
                @change="handleChange('desirePositionType',jobExpectData.desirePositionType )"
                >
            </el-cascader>
          </el-form-item>
        </el-col>



        <el-col :span="16">
          <el-form-item label="行业类型：" prop="desireIndustry">
            <el-select
              v-model="jobExpectData.desireIndustry"
              placeholder="请选择行业类型"
            >
              <el-option
                :label="item.name"
                v-for="item in industryType"
                :key="item.code"
                :value="item.code"
                >{{ item.name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <el-form-item label="期望城市：" prop="desireCity">
            <el-select
              v-model="jobExpectData.desireCity"
              placeholder="请选择期望城市"
            >
              <el-option
                :label="item.cityName"
                v-for="item in positionArea"
                :key="item.cityCode"
                :value="item.cityCode"
                >{{ item.cityName }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <div class="flex">
            <el-form-item label="期望薪酬：" prop="desireSalaryMin">
                <el-input v-model="jobExpectData.desireSalaryMin" placeholder="最低薪酬">
                  <template slot="append">K</template></el-input>
            </el-form-item>
            <p style="padding:8px 6px 0 ;color: rgba(0,0,0,0.5);">至</p>
            <el-form-item label="" prop="desireSalaryMax" label-width="0">
                  <el-input v-model="jobExpectData.desireSalaryMax" placeholder="最高薪酬">
                    <template slot="append">K</template>
                  </el-input>
            </el-form-item>
          </div>
        </el-col> 

        <el-col :span="24" style="text-align: center">
          <el-button @click="next">{{ cancelText }}</el-button>
          <el-button type="primary" @click="addJobExpectAction">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions,mapState } from "vuex";
export default {
  props: ["value", "index", "type", "cancelText"],
  data() {
    return {
      jobExpectData: {}
    };
  },
  created() {
    this.jobExpectData = this.value;
    console.log(this.allJob,898989898)
  },
  computed: {
    ...mapGetters([
        "qualificationsType", 
        "schoolType",
        "positionType",   //求职类型-->兼职，全职
        "industryType",   //行业类型

    ]),
    ...mapState({
        positionArea:state => state.jobs.positionArea,
        allJob:state => state.jobs.allJob,
      }),
    rules() {
        let validatorSalarymin = (rule, value, callback) => {
            if (!Number(value)) {
                callback(new Error('请输入数字'));
            }else if(value=="" || this.jobExpectData.desireSalaryMax==""){
                callback(new Error('请至少输入一个薪酬'));
            }else{
                callback();
            }
        };
        let validatorSalarymax = (rule, value, callback) => {
            if (!Number(value)) {
                callback(new Error('请输入数字'));
            }else if(value=="" || this.jobExpectData.desireSalaryMin==""){
                callback(new Error('请至少输入一个薪酬'));
            }else if( Number(value) < Number (this.jobExpectData.desireSalaryMin)){
                callback(new Error('最高薪酬不能小于最低薪酬'));
            }else{
                callback();
            }
        };

      return {
        jobHuntType: [
          { required: true, trigger: "blur", message: "求职类型必填" }
        ],
        desirePositionType: [
          { required: true, trigger: "change", message: "期望职位类型必填" }
        ],
        desireIndustry: [
          { required: true, trigger: "change", message: "期望行业必填" }
        ],
        desireCity: [
          { required: true, trigger: "blur", message: "期望城市必填" }
        ],
        startTime: [
          { required: true, trigger: "change", message: "上学时间必填" }
        ],
        desireSalaryMin: [
          { required: true, trigger: "change", message: "" ,validator:validatorSalarymin}
        ],
        desireSalaryMax: [
          { required: true, trigger: "change", message: "",validator:validatorSalarymax }
        ]
      };
    },
    
   
  },
  methods: {
    ...mapActions(["addJobExpect", "editJobExpect"]),
    async addJobExpectAction() {
      const validate = await this.$refs["jobExpect"].validate();
      if (!validate) return;
      const actionType = this.type == "edit" ? "editJobExpect" : "addJobExpect";
      const res = await this[actionType](this.jobExpectData);
      if (res.code === 200) {
        if (this.type !== "edit") {
          this.$emit("input", res.data);
        }
        this.$emit("submit", this.index);
        this.$message.success("成功");
      } else {
        this.$message.error(res.message);
      }
    },
    next() {
      this.$emit("submit", this.index);
    },
    changeValueChange(value){
      console.log(value,888888)
    },
    handleChange(type,value){
      this.jobExpectData[type] = value[value.length-1]
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.jobexpect-edit {
  background: #F2F6FA;
  border-radius: 6px;
  padding: 24px;
}
</style>
